module.exports = __webpack_public_path__ + "media/images/logo-watermark-dc357d03c4fb7da87a24b647a9976a23.svg";